import type { ListBuilderMobileCardConfig } from '../../types';

/**
 * Required fields for quote_shop_default list
 */
export const QUOTE_SHOP_DEFAULT_REQUIRED_FIELDS = [
	'_id',
	'primaryImageUrl',
	'category',
	'description',
	'externalId',
	'externalId2',
	'manufacturer',
	'minimumPrice',
	'price',
	'quantityOnHand',
	'quantityReserved',
	'quantityOnOrder',
	'sizeCount',
	'soonestExpirationDate',
	'subcategory',
	'unitOfMeasure',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
];

/**
 * Required fields for quote_shop secondary lists
 */
export const QUOTE_SHOP_STANDARD_REQUIRED_FIELDS = [
	'client_shop._id',
	'client_shop.primaryImageUrl',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
	'item._id',
	'item.category',
	'item.description',
	'item.externalId',
	'item.manufacturer',
	'item.minimumPrice',
	'item.price',
	'item.quantityOnHand',
	'item.quantityReserved',
	'item.quantityOnOrder',
	'item.sizeCount',
	'item.soonestExpirationDate',
	'item.subcategory',
	'item.unitOfMeasure',
];

/**
 * Standard mobile card config for quote shop lists
 */
export const QUOTE_SHOP_MOBILE_CARD_CONFIG: ListBuilderMobileCardConfig = {
	primaryFields: ['item_details'],
	secondaryFields: ['category', 'stock'],
	controlsColumns: ['quantity', 'price'],
	hiddenFields: ['image'],
};
